import React from 'react';

import Typography from '@material-ui/core/Typography';

import { Actions, store } from '../../appredux'

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';


type DialogDeleteProps = {
  close: () => void,
  open: boolean
  //open : boolean
}

class DialogDelete extends React.Component<DialogDeleteProps, any> {

  // componentDidUpdate(prevProps: DialogDeleteProps) {
  //     if(this.props.page.dialogDelete !== prevProps.page.dialogDelete)
  //       this.setState({
  //         open: true
  //       });
  //   };

  // closeDeleteBasket = () => {
  //     this.setState({open: false})

  //   };

  deleteBasket = () => {
    store.dispatch(Actions.pageState.updateBasket([]));
    store.dispatch(Actions.pageState.setPriorytet());
    store.dispatch(Actions.pageState.setAsortymentowWGrupie(0));
    this.props.close()
  }

  //PM 2021-11-03
  //poprawka DOM
  render() {

    return (
      <Dialog
        disableEscapeKeyDown
        maxWidth="xs"
        open={this.props.open}
        fullWidth
      >
        <DialogTitle disableTypography>
          <Typography gutterBottom variant="h5" component="h2" color="primary" style={{ fontSize: "1.25rem" }}>
            <b>wybierz</b>
          </Typography>
          <hr style={{ marginTop: "10px" }} />
        </DialogTitle>
        <DialogContent >
          <DialogContentText gutterBottom variant="h5" component="h2">
            {"Czy na pewno wyczyścić koszyk?"}
          </DialogContentText>
        </DialogContent >
        <DialogActions >
          <Button onClick={() => this.props.close()} variant="outlined" size="small" color="primary"
            style={{ textTransform: "none", fontSize: "0.8rem" }}
          >
            <b>nie</b> {/*<Trans>Back</Trans>*/}
          </Button>
          <Button onClick={() => this.deleteBasket()} variant="contained" size="small" color="primary"
            style={{ textTransform: "none", fontSize: "0.8rem" }}
          >
            <b>tak</b>{/*<Trans>Next</Trans> */}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default DialogDelete;